import React, { useMemo } from 'react';
import styled from 'styled-components';

import ModuloCard from './ModuloCard';
import ModuloCardAdicionado from './ModuloCardAdicionado';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SectionHeader = styled.div<{ $color?: string }>`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 14px;
  color: ${props => props.$color || '#495057'};
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PlaceholderMessage = styled.div`
  padding: 10px;
  background-color: #e9ecef;
  border-radius: 4px;
  color: #6c757d;
  font-style: italic;
  font-size: 13px;
`;

export const ModulosGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

type Props = {
  adicionados: string[];
  removidos: string[];
  getModuloDescricao?: (nomeModulo: string) => string;
};

const ModulosDiferencaView: React.FC<Props> = ({
  adicionados,
  removidos,
  getModuloDescricao = (modulo: string) => modulo
}) => {
  const adicionadosOrdenados = useMemo(() => {
    return [...adicionados].sort((a, b) =>
      getModuloDescricao(a).localeCompare(getModuloDescricao(b))
    );
  }, [adicionados, getModuloDescricao]);

  const removidosOrdenados = useMemo(() => {
    return [...removidos].sort((a, b) =>
      getModuloDescricao(a).localeCompare(getModuloDescricao(b))
    );
  }, [removidos, getModuloDescricao]);

  return (
    <Container>
      <div>
        <SectionHeader $color="#28a745">
          <i className="fa fa-plus-circle" />
          Adicionados ({adicionados.length})
        </SectionHeader>
        {adicionados.length ? (
          <ModulosGrid>
            {adicionadosOrdenados.map(modulo => (
              <ModuloCardAdicionado key={modulo}>
                {getModuloDescricao(modulo)}
              </ModuloCardAdicionado>
            ))}
          </ModulosGrid>
        ) : (
          <PlaceholderMessage>Nenhum módulo adicionado</PlaceholderMessage>
        )}
      </div>

      <div>
        <SectionHeader $color="#dc3545">
          <i className="fa fa-minus-circle" />
          Removidos ({removidos.length})
        </SectionHeader>
        {removidos.length ? (
          <ModulosGrid>
            {removidosOrdenados.map(modulo => (
              <ModuloCard
                key={modulo}
                backgroundColor="#f8d7da"
                borderColor="#dc3545"
                color="#721c24"
              >
                {getModuloDescricao(modulo)}
              </ModuloCard>
            ))}
          </ModulosGrid>
        ) : (
          <PlaceholderMessage>Nenhum módulo removido</PlaceholderMessage>
        )}
      </div>
    </Container>
  );
};

export default ModulosDiferencaView;
